import { api } from '../services/api';

export interface IEmpresaQuota {
  empresa_id: number;
  dt_competencia: string;
  tela: string;
}

export const useEmpresaQuota = () => {
  const createQuota = async (data: IEmpresaQuota): Promise<any> => {
    const res = await api.post('/api/v1/empresas/quotas/', data);
    return res.data;
  };

  const deleteQuota = async (data: IEmpresaQuota): Promise<any> => {
    const res = await api.delete('/api/v1/empresas/quotas/', { data });
    return res.data;
  };

  const checkQuota = async (
    empresaId: number,
    dtCompetencia: string,
    tela: string,
  ): Promise<boolean> => {
    const res = await api.get('/api/v1/empresas/quotas/check/', {
      params: {
        empresa_id: empresaId,
        dt_competencia: dtCompetencia,
        tela,
      },
    });
    return res.data?.data ?? false;
  };

  return {
    createQuota,
    deleteQuota,
    checkQuota,
  };
};
